import moment from 'moment';
export default {
	/**버튼 권한 관리 */
	isPqyAdmin: false, // 관리자(승인)
	isPqyManager: false, //중간관리자(검토)
	isPqyStaff: false, //업무담당자(작성)
	isPqyGuest: false, //외부사용자(협력업체)

	isSaved: false,
	resultList: [],
	pagingInfo: PAGING_INFO(),
	detailForm: DETAIL_FORM(),
	searchParams: SEARCH_PARAMS(),

	/**eo4m 상세 팝업 검색 */
	popupSearchParams: POPUP_SEARCH_PARAMS(),
	rmkHistory: [],

	/**selectBox */
	isirCsetScnCd: [],
	isirCsetScnCdList2: [],
	partGCdList: [],
	pgsStEmCdList: [],
	vrfRsltCdList: [],
	altrTypeCdList: [],
	partClCdList: [],
	commCodeList: [],
	sndStCdList: [],
	altrLgrpList: [],
	altrSgrpList: [],

	/**eo4m 찾기 팝업 */
	findPopupResultList: [],
	findPopupSearchParams: SEARCH_PARAMS(),
	findPopupPagingInfo: PAGING_INFO(),

	/**이메일 관련 */
	rcptInfo: new Map(),
	rfpInfo: new Map()
};

function SEARCH_PARAMS() {
	return {
		strDt: moment().subtract(1, 'months').format('YYYY-MM-DD'),
		endDt: moment().format('YYYY-MM-DD'),
		partNo: '', //부품코드
		partNm: '', //부품코드
		altrNo: '', //변경번호
		cofCd: '', //협력사코드 (10)
		cofNm: '',
		pgsStEmCd: '', //진행상태
		isirCsetScnCd: '' //isir
	};
}

function POPUP_SEARCH_PARAMS() {
	return {
		partNo: '',
		altrNo: '',
		rfp: '',
		rcpt: ''
	};
}

function DETAIL_FORM() {
	return {
		apcnId: '', // 등록자
		apcnNm: '', // 등록자
		vrfId: '', //검토자
		vrfNm: '',
		csetNm: '',
		csetId: '', // 승인자
		apcnDd: '', // 등록일
		vrfFinDd: '', // 검토일
		csetFinDd: '', // 승인일
		rgnId: '',

		emlSndNo: '',
		sndStCd: 'NSND',
		dsprId: '',
		dsprNm: '',
		rcptNm: '',
		rfpNm: '',
		dsprAdr: '',
		rcptAdr: '',
		rfpAdr: '',

		partNo: '', //품번
		partNm: '', //품명
		pgsStCd: '', //진행상태코드
		partGCd: '', // 소싱구분
		partClCd: '', //부품분류
		altrNo: '', //변경 no
		altrDlvgDd: '', //변경납품일
		altrDd: '', //변경일
		altrTypeCd: '', //변경 유형
		altrPrvsLgrpCd: '', //변경항목 - 대분류
		altrPrvsSgrpCd: '', //변경항목 - 소분류
		isirCsetScnCd: '', //ISIR승인구분코드
		sampQty: '', // 샘플수량
		vrfDd: '', //검증일
		vrfQty: '', //검증수량
		trwiDd: '', //투입일
		oldCofCd: '',
		cofCd: '', //협력사코드 (10)
		cofNm: '', //협력사명

		altrPurpSbc: '', //변경목적
		altrSbc: '', // 변경내용
		altrFileId: '', //변경 파일첨부
		altrFile: [], //변경 파일첨부
		altrPreFileId: '', // 변경 전 사양
		altrPreFile: {}, // 변경 전 사양
		altrAftFileId: '', // 변경 후 사양
		altrAftFile: {}, // 변경 후 사양

		vrfSbc: '', //검증내용
		rmk: '', //비고
		vrfFile: [], //파일첨부
		vrfFileId: '', //파일첨부
		vrfRsltCd: '', //검증결과
		ssId: '', //세션 아이디
		affrPrcsId: '', //업무처리Id

		/**db에서 받는 파일 정보 */
		altrFileDb: [],
		vrfFileDb: [],
		altrPreFileDb: {},
		altrAftFileDb: {}
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO, DETAIL_FORM, POPUP_SEARCH_PARAMS };
